<template>
  <div>
    <p>支付总金额：{{settlementResult.sum}} 元</p>
    <Table stripe :columns="columns" :data="settlementResult.data"></Table>
  </div>
</template>

<script>
export default {
  props: ['settlementResult'],
  data() {
    return {
      columns: [
        {
          title: '创建时间',
          width: 200,
          key: 'createDate',
          align: 'center'
        },
        {
          title: '支付单号',
          width: 200,
          align: 'center',
          key: 'payNo'
        },
        {
          title: '金额',
          width: 200,
          align: 'center',
          key: 'price'
        },
        {
          title: '支付方式',
          width: 200,
          align: 'center',
          key: 'payWay'
        },
        {
          title: '支付信息',
          width: 200,
          align: 'center',
          render: (h, param) => {
            return h('div', [
              h('p', {}, param.row.payTime),
              h('p', {}, param.row.payRemark),
              h('p', {}, param.row.payName)
            ])
          }
        },
        {
          title: '第三方流水号',
          width: 200,
          align: 'center',
          key: 'otherNo'
        }
      ]
    }
  },
  filters: {
    toPrice(price) {
      if (isNaN(price)) {
        return '¥ 0.00';
      }
      return '¥ '+(price/100).toFixed(2);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/order/order_detail/pay-detail.vue